import React, { FC } from 'react';
import { DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ClientLogo } from 'components';
import { useProtectedClient } from 'hooks';

const useStyles = makeStyles(theme => ({
  title: {
    margin: 0,
    borderBottom: `1px solid ${theme.custom.palette.grey3}`,
    zIndex: 1,
  },
}));

const Title: FC = () => {
  const classes = useStyles();
  const client = useProtectedClient();

  return (
    <DialogTitle className={classes.title}>
      <ClientLogo client={client} height={24} disableMargin />
    </DialogTitle>
  );
};

export default Title;
